export const AFFINITY_PROGRAM_REDIRECT_URL_MAX_LENGTH = 2048;

export type AffinityProgramRedirectUrlError = "required" | "invalid";

export const getAffinityProgramRedirectUrlError = (
  redirectUrl: string
): AffinityProgramRedirectUrlError | null => {
  const normalizedRedirectUrl = redirectUrl.trim();

  if (!normalizedRedirectUrl) {
    return "required";
  }

  if (
    normalizedRedirectUrl.length > AFFINITY_PROGRAM_REDIRECT_URL_MAX_LENGTH
  ) {
    return "invalid";
  }

  try {
    const parsedRedirectUrl = new URL(normalizedRedirectUrl);

    if (
      parsedRedirectUrl.protocol !== "http:" &&
      parsedRedirectUrl.protocol !== "https:"
    ) {
      return "invalid";
    }
  } catch (_error) {
    return "invalid";
  }

  return null;
};
